module.exports = __webpack_public_path__ + "img/the-plan-latest.50036f75.svg";